import { useState } from "react";

import { Button } from "@components/Button";
import { Drawer } from "@components/Drawer";
import { Input } from "@components/Input";
import { Label } from "@components/Label";
import { Loading } from "@components/Loading";

import style from "@styles/pages/cdp/cdp.module.scss";

import { If } from "@components/control-statements";
import { Cdp } from "shared/core/cdp";

const Options = {
  XLS: "XLS",
  EMAIL: "EMAIL",
  DRIVE: "DRIVE",
};

const download = (filename) => {
  const a = document.createElement("a");
  a.setAttribute("href", filename);
  a.setAttribute("download", true);
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export default function ExportAudience({
  visible,
  execution_id = null,
  audience = null,
  state,
  onClose,
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [finishedSave, setFinishedSave] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(audience?.name || "");

  const getTitle = () => {
    const Titles = {
      XLS: "Exportar XLS",
      EMAIL: "Enviar por e-mail",
      DRIVE: "Salvar no drive",
    };

    return Titles[selectedOption] || "Compartilhar";
  };

  const save_hub = async () => {
    switch (selectedOption) {
      case Options.XLS: {
        try {
          setLoading(true);
          const response = await Cdp.export(
            execution_id,
            audience?.id,
            state?.filters || []
          );
          if (!response || response?.status == "ERROR") {
            throw new Error("Ocorreu um erro ao exportar o público");
          }
          download(response?.link);
          setLoading(false);
        } catch (err) {
          alert({ text: err.message });
          setLoading(false);
          return false;
        }
        break;
      }
      case Options.EMAIL: {
        break;
      }
      default:
        break;
    }
    setName("");
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => {
        onClose();
        setFinishedSave(false);
        setName("");
      }}
      title={getTitle()}
      showCloseButton
    >
      <If cond={!loading}>
        <If cond={!selectedOption}>
          <div className={style.exportOptions}>
            <div
              className={style.option}
              onClick={() => setSelectedOption(Options.XLS)}
            >
              <div className="d-flex align-center">
                <div className={style.icon}>
                  <i className="fal fa-download" />
                </div>
                <p>Exportar XLS</p>
              </div>
              <i className="fas fa-chevron-right" />
            </div>
            {/* <div
              className={style.option}
              onClick={() => setSelectedOption(Options.EMAIL)}
            >
              <div className="d-flex align-center">
                <div className={style.icon}>
                  <i className="fal fa-at" />
                </div>
                <p>Enviar para e-mail</p>
              </div>
              <i className="fas fa-chevron-right" />
            </div>
            <div
              className={style.option}
              // onClick={() => setSelectedOption(Options.DRIVE)}
            >
              <div className="d-flex align-center">
                <div className={style.icon}>
                  <i className="fab fa-google-drive" />
                </div>
                <p>Salvar no drive</p>
              </div>
              <i className="fas fa-chevron-right" />
            </div> */}
          </div>
        </If>
        <If cond={selectedOption === Options.XLS}>
          <Label>
            Você gostaria de realizar o download do arquivo XLS deste público?
          </Label>
          <Button
            className="mb-10 mt-20"
            onClick={save_hub}
            loading={loading}
            disabled={loading}
            design="primary"
          >
            Realizar download
          </Button>
          <Button
            design="two"
            onClick={() => setSelectedOption(null)}
            loading={loading}
            disabled={loading}
          >
            Cancelar
          </Button>
        </If>

        <If cond={selectedOption === Options.EMAIL}>
          <Label>Informe o endereço de e-mail:</Label>
          <Input placeholder="E-mail" />
        </If>

        <If cond={selectedOption && !loading}>
          <div className={style.footer} onClick={save_hub}>
            <If
              cond={
                !finishedSave &&
                [Options.SAVE, Options.EMAIL].includes(selectedOption)
              }
            >
              <Button
                className="w-100"
                disabled={name.length < 3}
                onClick={save_hub}
                design="primary"
              >
                Salvar
              </Button>
            </If>
            <If cond={finishedSave}>
              <Button
                design="primary"
                className="w-100"
                text={"Concluir"}
                onClick={() => {
                  onClose();
                  setSelectedOption(null);
                  setFinishedSave(false);
                }}
              />
            </If>
          </div>
        </If>
      </If>

      <If cond={loading}>
        <div className={style.loading}>
          <Loading />
        </div>
      </If>
    </Drawer>
  );
}
